import React from "react";
import Button from "../../../ui/Button";
import Modal from "../../../ui/Modal";
import { colors, radius, spacing, typography } from "../../../ui/tokens";
import ControlsHealthPrintPreview from "./ControlsHealthPrintPreview";

const helperPanelStyle = {
  display: "grid",
  gap: spacing.md,
};

const noteStyle = {
  border: `1px solid ${colors.border}`,
  background: colors.surfaceSubtle,
  color: colors.text,
  borderRadius: radius.sm,
  padding: spacing.md,
  fontSize: typography.size.sm,
};

const warningStyle = {
  border: `1px solid ${colors.warningBorder}`,
  background: colors.warningSubtle,
  color: colors.warning,
  borderRadius: radius.sm,
  padding: spacing.md,
  fontSize: typography.size.sm,
};

export default function ControlsHealthPrintModal({
  open,
  data,
  filters,
  previewVisible,
  overflow,
  onCancel,
  onPreview,
  onPrint,
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title="Print controls health to one page"
      description="Preview the current controls health snapshot. The output is formatted to fit on a single A4 page."
      size="xl"
      footer={(
        <>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onPreview}>
            Preview PDF
          </Button>
          <Button variant="primary" onClick={onPrint}>
            Print / Download PDF
          </Button>
        </>
      )}
    >
      <div style={helperPanelStyle}>
        <div style={noteStyle}>
          The print layout shows the KPI summary, top attention items, owner breakdown, recent changes, and the active filters.
        </div>
        {overflow?.likelyOverflow && (
          <div role="alert" style={warningStyle}>
            The current snapshot is being condensed to one page. Additional attention rows or recent changes will be summarized.
          </div>
        )}
        {previewVisible && data && (
          <ControlsHealthPrintPreview
            data={data}
            filters={filters}
            screen
            testId="controls-health-print-preview-screen"
          />
        )}
      </div>
    </Modal>
  );
}
